<template>
  <ResultComponent :history="bigSmallHistory" @showdetail="showdetail" />
</template>

<script>
import ResultComponent from '@components/taixiu/footer/result.vue';

export default {
  components: {
    ResultComponent
  },
  props: {
    data: { type: Object, default: () => ({})},
  },
  data() {
    return {
      selectedItem: "RESULT",
    }
  },
  computed: {
    bigSmallHistory: function () {
      return this.data.bigSmallHistory;
    },
  },
  methods: {
    showdetail(ref) {
      // console.log('footer - showdetail');
      this.$emit('showdetail', ref);
    }
  }
}
</script>

<style>

</style>
